import { parse } from "psl";

export const getBaseDomain = () => {
  const fullDomain = process.env.REACT_APP_API_ENTRYPOINT.replace(
    /^(?:https?:\/\/)?(?:www\.)?/i,
    ""
  ).split("/")[0];

  return parse(fullDomain).domain;
};

export const replaceSpecialCharacters = (word) => {
  let newWord = "";
  const specialChars = { ç: "c", ë: "e", ü: "ue", ä: "ae", ö: "oe", ß: "ss" };

  [...word].forEach((char) => {
    newWord += specialChars[char] || char;
  });

  newWord = newWord.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

  return newWord;
};
